<div class="si-appo-arrival-confirm-button">
  <button class="si-button_main w-100"
          type="button"
          (click)="onClickConfirmButton()">
    <span>{{'SI_CONFIRM_ATTENDANCE' | translate}}</span>
  </button>
</div>
<ng-container *ngIf="displayConfirmAttendanceDialog">
  <si-appo-attendance-confirm-dialog [(displayDialog)]="displayConfirmAttendanceDialog"
                                     [appoId]="appoId"
                                     [serviceName]="serviceName"
                                     [startDate]="startDate"
                                     [assistanceTypeName]="appointmentAssistanceTypeName[assistanceTypeCode?.toString()]"
                                     (appoAttendanceConfirmed)="onConfirmAttendance()"
  ></si-appo-attendance-confirm-dialog>
</ng-container>
